// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"030caf00","787":"8f79bfb0","850":"9a343052"}[chunkId] + ".chunk.js";
};